import * as React from "react";
import { useCallback } from "react";
import { FormControl } from "components/bootstrap";
import * as FormsUtils from "util/FormsUtils";
const GenericParameterInput = ({
  parameter: { optional, name },
  value,
  onChange,
  onBlur,
  inputSize
}) => {
  const _onChange = useCallback(
    (e) => {
      const newValue = FormsUtils.getValueFromInput(e.target);
      return onChange(name, newValue);
    },
    [name, onChange]
  );
  return /* @__PURE__ */ React.createElement(
    FormControl,
    {
      type: "text",
      bsSize: inputSize,
      "aria-label": name,
      "data-testid": `generic-parameter-input-${name}`,
      placeholder: "Please enter a parameter value...",
      required: !optional,
      name,
      value,
      onBlur,
      onChange: _onChange
    }
  );
};
export default GenericParameterInput;
